import { render, staticRenderFns } from "./ReportsDeliveryMonthView.vue?vue&type=template&id=652e0350"
import script from "./ReportsDeliveryMonthView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryMonthView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports